import { Spinner } from "@/ui/atoms/Spinner";
import { CheckIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

type ValidationCheckProps = {
    title: string;
    description: string;
    status: "warning" | "fail" | "pass" | "loading" | "neutral";
    detail?: string;
};

export default function ValidationCheck({
    title,
    description,
    status,
    detail,
}: ValidationCheckProps) {
    return (
        <div
            className={clsx(
                "bg-default-overlay-7 px-5 py-4",
                "flex flex-col",
                "gap-2 rounded-lg",
            )}
        >
            <div className={clsx("flex items-center gap-4")}>
                {status !== "loading" && (
                    <div
                        className={clsx(
                            "flex h-6 w-7 items-center justify-center rounded",
                            status === "neutral" && "border border-slate-400",
                            status === "fail" && "border border-red-400",
                            status === "pass" && "bg-blue-400",
                            status === "warning" && "border border-yellow-400",
                        )}
                    >
                        {status === "pass" && (
                            <CheckIcon className="size-4 fill-slate-800" />
                        )}
                    </div>
                )}
                {status === "loading" && <Spinner className="size-6" />}
                <div className="flex w-full flex-col gap-1">
                    <p className="lozenge">{title}</p>
                    <p
                        className={clsx(
                            "body-micro subdued",
                            status === "fail" && "text-red-400",
                            status === "warning" && "text-yellow-400",
                        )}
                    >
                        {description}
                    </p>
                </div>
            </div>
            {detail && (
                <p
                    className={clsx(
                        "body-micro subdued ml-10 whitespace-pre-line",
                        status === "fail" && "text-red-400",
                        status === "warning" && "text-yellow-400",
                    )}
                >
                    {detail}
                </p>
            )}
        </div>
    );
}
